<template>
  <Teleport to="body">
    <div
      v-if="show"
      ref="toast"
      class="toast"
    >
      <div class="toast-icon">
        <i class="hi hi-time"></i>
      </div>
      <div class="toast-container">
        <div class="toast-header">
          <strong class="mr-auto">{{ title }}</strong>
          <button
            type="button"
            class="close toast-close"
            @click="close"
          >
            <i class="hi hi-close" />
          </button>
        </div>
        <div class="toast-body">
          {{ message }}
        </div>
        <div class="toast-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close', 'openDialog'],
  methods: {
    close() {
      this.$emit('close');
    },

    openDialog() {
      this.$emit('openDialog');
    },
  },
};
</script>
